var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.627 24 24 18.6274 24 12C24 5.37256 18.627 0 12 0C5.37305 0 0 5.37256 0 12C0 18.6274 5.37305 24 12 24ZM13.4854 7.65332C13.5732 7.45996 13.6172 7.25195 13.6172 7.0293C13.6172 6.8125 13.5732 6.60742 13.4854 6.41406C13.4033 6.21484 13.2891 6.04492 13.1426 5.9043C12.9961 5.75781 12.8232 5.64355 12.624 5.56152C12.4307 5.47363 12.2227 5.42969 12 5.42969C11.7773 5.42969 11.5664 5.47363 11.3672 5.56152C11.2402 5.61523 11.124 5.68262 11.0176 5.76367C10.9619 5.80664 10.9082 5.85352 10.8574 5.9043C10.7168 6.04492 10.6025 6.21484 10.5146 6.41406C10.4326 6.60742 10.3916 6.8125 10.3916 7.0293C10.3916 7.25195 10.4326 7.45996 10.5146 7.65332C10.6025 7.84668 10.7168 8.0166 10.8574 8.16309C10.9453 8.24805 11.043 8.32324 11.1475 8.38916C11.2168 8.43213 11.29 8.47119 11.3672 8.50586C11.5664 8.58789 11.7773 8.62891 12 8.62891C12.2227 8.62891 12.4307 8.58789 12.624 8.50586C12.75 8.4502 12.8652 8.38428 12.9697 8.30762C13.0312 8.26318 13.0889 8.21484 13.1426 8.16309C13.2891 8.0166 13.4033 7.84668 13.4854 7.65332ZM10.7871 19H13.2041V9.58691H10.7871V19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b68a7e9d.svg";
export { ForwardRef as ReactComponent };